import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LinkAliasingSettings = lazy(() =>
  import("@scenes/EmailSettings/LinkAliasingSettings").then((module) => ({
    default: module.default,
  }))
);

export const linkAliasingSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("link-aliasing-settings-nro-heading", "Link Aliasing"),
  pageNameForTracking: () => "Link Aliasing",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("link_aliasing"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  Component: LinkAliasingSettings,
  componentFeatureFlippers: ["link_aliasing"],
  noKnockoutFallback: true,
};
